import { Injectable, NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { EnvironmentData, EnvironmentService } from 'pg-lib';
import { environment } from '../environments/environment';
import { EfLandingComponent } from './ef-landing/ef-landing.component';
import { EfProductViewComponent } from './ef-product-view/ef-product-view.component';
import { EfShowcaseViewComponent } from './ef-showcase-view/ef-showcase-view.component';

@Injectable({
    providedIn: 'root'
})
export class NoForceRealmGuard  {
    constructor(private environmentService:EnvironmentService) {}

    canActivate() {
        return this.environmentService.environment.ForceRealm == null;
    }
}

const routes: Routes = [{
    path: 'showcase',
    component: EfShowcaseViewComponent,
    data: {
        header: {
            hidden: true
        },
        footer: {
            hidden: true
        }
    }
}, {
    path: 'product/:resource/:id',
    component: EfProductViewComponent,
    data: {
        header: {
            back:(environment:EnvironmentService, params:any) => {
                return environment.externalParameters?.returnUrl;
            }
        }
    }
}, {
    path: 'realm/:realm/showcase',
    component: EfShowcaseViewComponent,
    data: {
        header: {
            hidden: true
        },
        footer: {
            hidden: true
        }
    }
}, {
    path: 'realm/:realm',
    component: EfLandingComponent,
    canActivate: [NoForceRealmGuard],
    data: {
        header: {
            back:(environment:EnvironmentService, params:any) => {
                return environment.externalParameters?.returnUrl;
            }
        }
    }
}, {
    path: ':pid/showcase',
    component: EfShowcaseViewComponent,
    data: {
        header: {
            hidden: true
        },
        footer: {
            hidden: true
        }
    }
}, {
    path: ':pid',
    component: EfLandingComponent,
    data: {
        header: {
            back:(environment:EnvironmentService, params:any) => {
                return environment.externalParameters?.returnUrl;
            }
        }
    }
}, {
    path: '',
    pathMatch: 'full',
    component: EfLandingComponent
}, {
    path: '**',
    redirectTo: ''
}];

@NgModule({
  imports: [RouterModule.forRoot(routes,  { useHash: ((environment as any) as EnvironmentData).AppMode == 'hybrid' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
